





















import { defineComponent, computed } from '@nuxtjs/composition-api';

export default defineComponent({
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const getCustomField = (data, fieldKey) => {
      return (
        data?.custom_fields?.find((field) => field.key === fieldKey) ?? null
      );
    };

    const media = computed(
      () =>
        props.data?.media?.[0]?.media_path ||
        props.data?.urls?.[0]?.media_path ||
        ''
    );

    const altText = computed(
      () =>
        props.data?.media?.[0]?.media_file_name ||
        props.data?.urls?.[0]?.media_file_name ||
        ''
    );

    const linkData = computed(() => props.data?.urls?.[0]);

    const title = computed(
      () => getCustomField(props.data, 'title')?.value_string || ''
    );
    const titleTag = computed(
      () => getCustomField(props.data, 'title_head')?.value_select || 'h3'
    );

    const subtitle = computed(
      () => getCustomField(props.data, 'text')?.value_string || ''
    );

    return {
      media,
      altText,
      linkData,
      title,
      titleTag,
      subtitle
    };
  }
});
